import { initAccordion } from './components/accordion.js';

document.addEventListener('DOMContentLoaded', () => {
    const tocButton = document.querySelector('.case-toc__title');
    const tocDetail = document.querySelector('.case-toc__detail');

    if (!tocButton || !tocDetail) return;

    const syncExpandedState = () => {
        tocButton.setAttribute('aria-expanded', String(tocButton.classList.contains('active')));
    };

    tocButton.addEventListener('click', () => {
        tocButton.setAttribute('aria-expanded', String(!tocButton.classList.contains('active')));
    });

    initAccordion('.case-toc__title', '.case-toc__detail', 'active', syncExpandedState);
    syncExpandedState();
});
